<template>
  <div class="main-buy-and-sell">
    <div class="buttons">

      <button @click="select = 'price'" class="solid-gray-btn" :class="{'gray-btn' : select === 'price'}">
        Market
      </button>

      <button @click="select = 'limit'" class="solid-gray-btn" :class="{'gray-btn' : select === 'limit'}">
        LimitOrder
      </button>

      <button @click="select = 'Stop-Limit'" class="solid-gray-btn" :class="{'gray-btn' : select === 'Stop-Limit'}">
        Stop-Limit
      </button>

      <button @click="select = 'OCO'" class="solid-gray-btn" :class="{'gray-btn' : select === 'OCO'}">
        OCO
      </button>
    </div>
    <div class="buy-and-sell" v-if="state.token">
<buy-menu :cash="buyCredit" :data="data" :select="select" :decimal="8" :id="1" :key="'buy'+select" :role="role"/>
      <sell-menu :cash="sellCredit" :data="data" :select="select" :decimal="8" :id="2" :key="'sell'+select" :role="role"/>
    </div>
    <div class="buy-and-sell alarm" v-if="!state.token">
      <div class="no-token">
        <div class="no-token-text">
          <p>
            برای انجام معامله باید به سایت وارد شوید.
          </p>
          <p>
            <buttton  class="btn" @click.prevent="$router.push({name:'Login'})">ورود</buttton>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buyModal from "@/views/trade/components/buyModal";
import sellModal from "@/views/trade/components/sellModal";

import {tradeTo,tradeFrom} from "@/lib/reuseableFunction";
import buyMenu from "@/views/trade/components/shop/buyMenu";
import sellMenu from "./sellMenu";

export default {
  name: "buy-and-sell",
  components: {
  buyMenu,
    sellMenu,
    buyModal,
    sellModal,


  },
  props: ['data'],
  computed: {
    tradeTo,
    tradeFrom
  },

  data() {
    return {
      select: 'price',
      role:{},
      sellCredit: 0,
      buyCredit: 0,

    }
  },

  methods: {

    async getWalletCredit() {
      this.state.loading=true
      if (this.state.userInfo.authorized) {
        const res = await this.$axios.get('/wallets/customer-addresses?walletType=P2P', {
          params: {
            coins: `${this.tradeFrom},${this.tradeTo}`

          }
        })
// console.log(res)
        this.sellCredit = res[this.$route.params.tradeFrom].credit || 0
        this.buyCredit = res[this.$route.params.tradeTo].credit || 0

        //get role
        const coins = await this.$axios('/coins')
        this.role= coins.content.find((a)=>a.coin === this.tradeFrom)
        // console.log(this.role)
        // console.log('buy-credit:',this.buyCredit,'sell-credit:',this.sellCredit)
        this.state.loading=false

      }
    },
  },
  created() {
    this.getWalletCredit()
  },
}
</script>

<style lang="scss" scoped>
.btn{
  background: linear-gradient(181.54deg, #1199FA 1.31%, #123249 180.79%);
  border-radius: 4px;
  color: white;
  font-size: clamp(10px , 2vw , 12px);
  cursor: pointer;
  height: 36px;
  width: 100%;
  padding: 10px;
}
.alarm{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.no-token {
align-self: center;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.no-token-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
//public class
.less-border{
  border: none !important;
}
.gray-btn {
  background: rgba(215, 200, 200, 0.12) !important;
  border-radius: 4px !important;
  color: rgba(17, 153, 250, 1) !important;
  cursor: pointer !important;
  font-size: clamp(10px, 2vw, 12px) !important;
  height: auto;
  width: auto;
}

.buyBtn {
  width: 100%;
  height: 36px;
  background: #04B3A2;
  border-radius: 4px;
  color: #FFFFFF;
  cursor: pointer;
  position: absolute;
  bottom: 0;

  &:hover {
    background: linear-gradient(180deg, #03DAC5 0%, rgba(140, 166, 142, 0) 425%);
  }
}

.sellBtn {
  width: 100%;
  height: 36px;
  background: #D94F68;
  border-radius: 4px;
  color: #FFFFFF;
  cursor: pointer;
  position: absolute;
  bottom: 0;

  &:hover {
    background: linear-gradient(180deg, #D94F68 0%, rgba(255, 60, 95, 0) 355.56%);
  }
}

.main-buy-and-sell {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  direction: rtl;

  .buttons {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    button {
      width: 150px;
      height: 25px;
    }
  }

  .range {
    display: flex;
    width: 100%;
    height: 20px;
    flex-direction: column;
    gap: 10px;
    position: absolute;
    bottom: 130px;

  }

  .text-rang {
    display: flex;
    width: 100%;
    justify-content: space-between;
    font-size: 10px;
    color: rgba(215, 200, 200, 1);
    position: absolute;
    bottom: 100px;
  }

  .resive {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 10px;
    border: 1px solid #8C8585;
    box-sizing: border-box;
    border-radius: 4px;
    align-items: center;
    width: 100%;
    height: 36px;
    position: absolute;
    bottom: 50px;

    span {
      color: rgba(140, 133, 133, 1);
      font-size: 12px;
    }

    .input {
      display: flex;
      align-items: center;

      .resive-value {
        font-size: 14px;
        color: #FFFFFF;
        margin-left: 10px;
      }
    }
  }

  .buy-and-sell {
    display: flex;
    flex-direction: row;
    background: linear-gradient(180deg, rgba(140, 133, 133, 0.12) 0%, rgba(215, 200, 200, 0.0408) 100%);
    border-radius: 4px;
    min-height: 370px;
    gap: 20px;
    padding: 14px;
    flex-wrap: wrap;

    .box {
      display: flex;
      flex-grow: 1;
      flex-basis: 100px;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 16px;
      position: relative;

      .value {
        font-size: 10px;
        color: rgba(215, 200, 200, 1);
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 20px;
        direction: rtl;
      }

      .best-of-price-trade {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 36px;
        background: rgba(215, 200, 200, 0.12);
        border: 0.75px solid #8C8585;
        border-radius: 4px;
        margin-top: -10px;

        svg {
          margin-left: 6px;
        }

        .right {
          display: flex;
          flex-direction: column;
          text-align: right;
          flex-grow: 1;
          justify-content: start;
          margin-right: 6px;

          .trade-price {
            font-size: 10px;
            color: #1199FA;
          }

          .best-price {
            font-size: 11px;
            color: #FFFFFF;
          }
        }

        .left {
          display: flex;
          flex-grow: 1;
          align-items: center;
          justify-content: end;
          gap: 5px;

          .price {
            font-size: 12px;
            font-weight: bold;
          }
        }
      }

      .stop{
        @extend .best-of-price-trade;
        background: none !important;
      }


    }
  }
}

@media (max-width: 992px) {
  .buttons {
    gap: 10px !important;
  }
  .buttons button {
    width: auto !important;
  }

  .change-type {
    justify-content: space-between !important;
  }
}

@media (max-width: 500px) {
  .buy-and-sell {
    flex-direction: column !important;
    gap: 40px;
    min-height: 770px !important;
  }

  .box {
    gap: 10px;
  }

  .text-rang {
    margin-top: 10px;
  }
}

@media (max-width: 380px) {
  .main-trade {
    padding: 5px !important;
  }
}
</style>
<style lang="scss" scoped>
.focusebuy{
  font-size: 10px !important;
  color: rgba(17, 153, 250, 1) !important;
  position: absolute;
  top: 3px !important;
}

.activebuy{
  border: 1px solid #FFFFFF !important;
}

.unfocusebuy{
  color: rgba(115, 109, 109, 1) !important;
  font-size: 12px !important;
}

.input {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #736D6D;
  box-sizing: border-box;
  border-radius: 4px;
  height: 36px;
  width: 100%;
  padding: 8px;
  position: relative;

  >span{
    transition: top 0.3s , font-size 0.3s;
  }

  &:hover {
    border: 1px solid rgba(251, 251, 253, 1) !important;
  }

  &:hover .placeholder {
    color: rgba(215, 200, 200, 1);
  }

  .placeholder {
    color: rgba(115, 109, 109, 1);
    font-size: 12px;
    position: absolute;
    top: 25%;
  }

  .text-input {
    display: flex;
    flex-direction: row;
    gap: 5px;
    left: 5px;
    position: absolute;

    .inp-text {
      font-size: 12px;
      font-weight: bold;
      color: #FFFFFF;
      text-align: left;
    }
  }

  .inp-text:hover .placeholder {
    color: #1199FA !important;
  }
}

</style>